import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, ShieldCheck, Star } from "lucide-react";
import { company, heroStats, heroImages } from "../../mock";

export default function Hero() {
  return (
    <section className="relative overflow-hidden bg-[#0b1f3a] text-white">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={heroImages.skyline}
          alt="Commercial real estate skyline"
          className="h-full w-full object-cover ltr-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0b1f3a] via-[#0b1f3a]/70 to-[#0b1f3a]/20" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0b1f3a] via-transparent to-transparent" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 ring-1 ring-white/15 px-4 py-1.5 text-sm font-medium backdrop-blur">
            <ShieldCheck className="h-4 w-4 text-[#c6a15b]" />
            Your Partner In Real Estate Investment
          </div>

          <h1 className="font-display font-extrabold tracking-tight text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            Secure <span className="text-[#c6a15b]">Funding</span> For Your Business
          </h1>
          <p className="mt-6 text-lg text-slate-200 leading-relaxed max-w-xl">
            Commercial real estate financing &amp; refinancing with trusted, reliable and efficient
            service. Loan programs competitively priced with amounts up to{" "}
            <span className="text-white font-semibold">{company.maxLoan}</span>.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4">
            <Link
              to="/apply"
              className="group inline-flex items-center justify-center gap-2 rounded-md bg-[#c6a15b] px-7 py-3.5 font-bold text-[#0b1f3a] hover:bg-[#d8bc85] transition-colors shadow-lg shadow-black/20"
            >
              Apply Now
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
            <a
              href={`tel:${company.phoneTel}`}
              className="inline-flex items-center justify-center gap-2 rounded-md border border-white/25 bg-white/5 px-7 py-3.5 font-semibold text-white hover:bg-white/10 transition-colors backdrop-blur"
            >
              <Phone className="h-5 w-5" />
              {company.phoneDisplay}
            </a>
          </div>

          <div className="mt-8 flex items-center gap-3 text-sm text-slate-300">
            <div className="flex text-[#c6a15b]">
              {[...Array(5)].map((_, i) => (
                <Star key={`hero-star-${i}`} className="h-4 w-4 fill-current" />
              ))}
            </div>
            <span>Trusted by 5,000+ businesses nationwide</span>
          </div>
        </div>
      </div>

      {/* Stats strip */}
      <div className="relative border-t border-white/10 bg-[#0a1a2f]/70 backdrop-blur">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-white/10">
            {heroStats.map((s) => (
              <div key={s.label} className="py-7 px-4 text-center">
                <div className="font-display text-3xl lg:text-4xl font-extrabold text-[#c6a15b]">{s.value}</div>
                <div className="mt-1 text-xs sm:text-sm text-slate-300 uppercase tracking-wide">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
